import {gsap} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Game} from "../Game";
import {GameFeatureMode} from "../enums/Enum";
import {BitmapText} from "pixi.js";
import {GameAssets} from "../GameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Sound} from "../sound/Sound";

export class UpgradeView extends PIXI.Container implements StageLayer {
    private _fsIntro: PIXI.spine.Spine;
    private _upgradeSprite: PIXI.Sprite;
    private _spins: PIXI.BitmapText;

    constructor() {
        super();
        this.name = "UpgradeView";
        this.init()
    }

    public playLift(nextMode: GameFeatureMode): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(Game.reelView.hide());
        tl.add(Game.backgroundElements.playLiftAnim(nextMode));
        return tl;
    }

    public show(nextMode: GameFeatureMode): gsap.core.Timeline {
        const spineName: string = nextMode === GameFeatureMode.FREESPIN_SUPER ? "sfs" : "cfs";
        this._upgradeSprite.position.y = nextMode === GameFeatureMode.FREESPIN_SUPER ? 255 : 360;
        this._spins.tint = nextMode === GameFeatureMode.FREESPIN_SUPER ? 0xff0000 : 0x777676;
        const prevCount: number = Game.model.previousFSLeftCount - 1;
        const currentCount: number = Game.model.data.freespinsLeft;
        this._spins.text = prevCount + "";

        if (nextMode === GameFeatureMode.FREESPIN_SUPER) {
            this._spins.position.y = 530;
        } else {
            this._spins.position.y = 650;
        }
        this.createBG(spineName + "IntroOutro");
        this.alpha = 0;
        this._upgradeSprite.alpha = 1;
        this.visible = true;
        const showFsIntroTl: gsap.core.Timeline = new gsap.core.Timeline();

        showFsIntroTl.add([
            gsap.to(this, {duration: 0.1, alpha: 1}),
            gsap.to(this._spins, {duration: 0.3, alpha: 1}),
            gsap.to(this._fsIntro, {duration: 1, alpha: 1}),
            () => {
                this._fsIntro.state.setAnimation(0, spineName + "_intro_loop", true);
                if (nextMode === GameFeatureMode.FREESPIN_SUPER) {
                    Game.soundPlayer.playSound(Sound.UPGRADE_SCREEN_TO_SFS);
                } else {
                    Game.soundPlayer.playSound(Sound.UPGRADE_SCREEN_TO_CFS);
                }
            }
        ]);
        const counterTl: gsap.core.Timeline = new gsap.core.Timeline();
        for (let counter: number = prevCount; counter <= currentCount; counter++) {
            counterTl.to(this._spins, {
                duration: 0.3, onComplete: () => {
                    Game.soundPlayer.playSound(Sound.UPGRADE_SCREEN_COUNT);
                    this._spins.text = counter + "";
                }
            })
        }
        showFsIntroTl.add(counterTl, 0.5);
        showFsIntroTl.add(this.onButtonClick(spineName), "+=1");
        return showFsIntroTl;
    }

    private onButtonClick(spineName: string): gsap.core.Timeline {
        const tl = new gsap.core.Timeline();
        const time: number = this._fsIntro.stateData.skeletonData.findAnimation(spineName + "_intro_out").duration;
        tl.add(() => {
            Game.soundPlayer.switchMusic(Game.model.data.nextMode)
            this._fsIntro.state.setAnimation(0, spineName + "_intro_out", false);
        });
        tl.add(() => {
            gsap.to(this._upgradeSprite, {duration: time / 2, alpha: 0});
            gsap.to(this._spins, {duration: time / 2, alpha: 0});
        }, time / 2);
        tl.add(() => {
            Game.keypadPlugin.show();
        });

        tl.add(() => {
            gsap.to(this, {
                duration: 0.1, alpha: 0, onComplete: () => {
                    this.visible = false;
                    this._fsIntro.destroy()
                    this.removeChildren();
                }
            });
        }, Math.max(time, tl.totalDuration()));
        return tl;
    }

    private createBG(spineName: string): void {
        this._fsIntro = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset(spineName));
        this._fsIntro.position.set(345, 360);
        this._fsIntro.alpha = 0;
        this.addChild(this._fsIntro, this._upgradeSprite, this._spins);
    }

    private init(): void {
        this._upgradeSprite = new PIXI.Sprite(Game.assetLoader.getTextures("freespine_intro/upgrade/upgrade_image")[0]);
        this._upgradeSprite.anchor.set(0.5);
        this._upgradeSprite.position.set(360, 255);
        this._upgradeSprite.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this._spins = new BitmapText(Game.model.data.freespinsLeft + "", {
            fontName: GameAssets.BITMAP_FONT_OPENSANS_800,
            fontSize: 192,
            tint: 0x027101
        });
        this._spins.anchor = new PIXI.Point(0.5, 0.5);
        this._spins.position.set(355, NolimitApplication.isLandscape ? 490 : 320);
        this._spins.alpha = 0;
        this.visible = false;
    }
}